var _circle, _path, _circle2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmarkGreenThin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#E8F2FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 1C15.7675 1 13.5569 1.43972 11.4944 2.29405C9.43185 3.14838 7.55778 4.40059 5.97918 5.97919C4.40059 7.55778 3.14838 9.43185 2.29405 11.4944C1.43972 13.5569 1 15.7675 1 18C1 20.2325 1.43972 22.4431 2.29405 24.5056C3.14838 26.5682 4.40059 28.4422 5.97919 30.0208C7.55778 31.5994 9.43185 32.8516 11.4944 33.706C13.5569 34.5603 15.7675 35 18 35C20.2325 35 22.4431 34.5603 24.5056 33.7059C26.5682 32.8516 28.4422 31.5994 30.0208 30.0208C31.5994 28.4422 32.8516 26.5681 33.706 24.5056C34.5603 22.4431 35 20.2325 35 18C35 15.7675 34.5603 13.5569 33.7059 11.4944C32.8516 9.43184 31.5994 7.55777 30.0208 5.97918C28.4422 4.40058 26.5681 3.14837 24.5056 2.29404C22.4431 1.43972 20.2325 0.999999 18 1L18 1Z",
    stroke: "#5BB383",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 16,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4383 14.8857C23.7894 14.4594 23.7284 13.8292 23.302 13.4781C22.8757 13.127 22.2455 13.188 21.8944 13.6143L23.4383 14.8857ZM16.2497 22.0417L15.4777 22.6774C15.6677 22.908 15.9509 23.0417 16.2497 23.0417C16.5485 23.0417 16.8316 22.908 17.0216 22.6774L16.2497 22.0417ZM14.1049 17.8643C13.7538 17.438 13.1236 17.377 12.6973 17.7281C12.271 18.0792 12.21 18.7094 12.5611 19.1357L14.1049 17.8643ZM21.8944 13.6143L15.4777 21.406L17.0216 22.6774L23.4383 14.8857L21.8944 13.6143ZM17.0216 21.406L14.1049 17.8643L12.5611 19.1357L15.4777 22.6774L17.0216 21.406Z",
    fill: "#59AD78"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkGreenThin);
export default __webpack_public_path__ + "static/media/checkmark-green-thin.3af178ea226eb3e21385269d03b0c042.svg";
export { ForwardRef as ReactComponent };